import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function VLSI_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-5'>1. Introduction to VLSI Systems</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          What is VLSI,  Historical Background, Importance of VLSI, Key Concepts in VLSI, Design Process, Applications, Future Trends.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-5'>2. MOS Transistor theory</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          MOS Transistor Structure, MOS Transistor Operation, Threshold Voltage (VT), MOS Transistor Modes, MOS Transistor as a Switch.<br></br>Layout Design Rules: - Minimum Feature Size (Minimum Width and Minimum Spacing), Aspect Ratio, Minimum Area, Clearance and Encroachment, Minimum Metal Width and Spacing, Contact and Via Rules, Minimum Gate Length, Well and Substrate Taps, Corner and Edge Spacing, Design Layer Ordering, Text and Labeling, Dummies and Fill Patterns, Alignment Marks, Keep-Out Zones, Electrical Rules.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-5'>3. CMOS logic, fabrication and layout</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          CMOS Logic, CMOS Fabrication, CMOS Layout.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-5'>4. Circuit Simulation & Memory system design</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Purpose of Circuit Simulation, Components of Circuit Simulation, Types of Circuit Simulators, Simulation Steps, Types of Circuit Analysis, Result Analysis, Iterative Process, Types of Memory in a System, Design Considerations, Memory Hierarchy, Memory Interface and Controller, Virtual Memory, Power Consumption, Error Handling and Redundancy, Testing and Validation. 
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-5'>5. Circuit characterization and performance estimation</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Circuit Characterization, Performance Estimation, Simulation and Tools.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-5'>6. Combinational and sequential circuit design</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Combinational Circuit Design, Sequential Circuit Design.  
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-5'>7. Design methodology and tools</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Design Methodology ( Design Thinking, Agile Development, Waterfall Model ), Design Tools (Computer-Aided Design (CAD) Software, Electronic Design Automation (EDA) Tools, Simulation and Modeling Software ) 
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-5'>8. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
